import { render, staticRenderFns } from "./ShowSocialSecurityComponent.vue?vue&type=template&id=4cba3aac&"
import script from "./ShowSocialSecurityComponent.vue?vue&type=script&lang=ts&"
export * from "./ShowSocialSecurityComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cba3aac')) {
      api.createRecord('4cba3aac', component.options)
    } else {
      api.reload('4cba3aac', component.options)
    }
    module.hot.accept("./ShowSocialSecurityComponent.vue?vue&type=template&id=4cba3aac&", function () {
      api.rerender('4cba3aac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Table/Elements/ShowSocialSecurityComponent.vue"
export default component.exports